import { render, staticRenderFns } from "./MetaForm.vue?vue&type=template&id=f2fbd21c"
import script from "./MetaForm.vue?vue&type=script&lang=js"
export * from "./MetaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports